import { observer } from 'mobx-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Typography from '@material-ui/core/Typography';
import BankData from '@components/BankData';

import useAccountsPayable from '@hooks/useAccountsPayable';
import useStore from '@hooks/useStore';

import useStyles from './styles';
import { formatClabe, formattedAmount } from '@utils/format';

export interface ICopyClipboardBank {}

const CopyClipboardBank: FC<ICopyClipboardBank> = () => {
  const { accountsPayableLink } = useStore();
  const { fundInfo, accountsPayable } = accountsPayableLink;
  const { getTotalAmount } = accountsPayable;
  const { showSuccessToast } = useAccountsPayable();
  const css = useStyles();
  const { t } = useTranslation();

  const handleOnCopy = () => {
    showSuccessToast({
      title: t('accountsPayable.toast.success.title'),
      message: t('accountsPayable.toast.success.copyText'),
    });
  };

  const bankDataList = [
    {
      label: t('accountsPayable.bankData.referenece'),
      value: fundInfo.reference,
      onCopy: handleOnCopy,
    },
    {
      label: t('accountsPayable.bankData.clabe'),
      value: formatClabe(fundInfo.clabe),
      onCopy: handleOnCopy,
    },
    {
      label: t('accountsPayable.bankData.beneficiary'),
      value: fundInfo.beneficiaryName,
      onCopy: handleOnCopy,
    },
    {
      label: t('accountsPayable.bankData.bank'),
      value: fundInfo.bank,
      onCopy: handleOnCopy,
    },
    {
      label: 'Monto',
      value: formattedAmount(fundInfo.amount, fundInfo.currency),
      onCopy: handleOnCopy,
    },
  ];

  return (
    <div className={css.card}>
      <div className={css.cardBankData}>
        <Typography variant="caption" className={css.cardTitle}>
          Información del pago mediante SPEI
        </Typography>
        <Typography variant="caption" className={css.cardInfoBanner}>
          <span className={css.blueBold}>¡Importante!</span> Asegúrate de ingresar correctamente el
          <span className={css.bold}> número de referencia</span> desde tu banca
        </Typography>
        <BankData className={css.bankData} bankDataList={bankDataList} />
      </div>
    </div>
  );
};

export default observer(CopyClipboardBank);
